export class ErrorResponse {
  constructor(data) {
    this.error = data.message;
    this.detail = data.detail ?? '';
    this.metadata = data.metadata ?? null;
  }
}
